export type StripeSessions = Record<string, string>;

export type PremiumOffer = {
  id: string;
  card_required: boolean;
  description: string;
  expires_at: string | null;
  name: string;
  pct_discount: number | null;
  terms: string;
  custom_terms?: string;
  trial_period_days: number | null;
  offer_type?: string;
  paid_trial_price_cents?: number | null;
  paid_trial_billing_cadence?: string | null;
  paid_trial_length?: number | null;
  paid_trial_unit?: string | null;
  paid_trial_inline_suffix?: string | null;
  paid_trial_after_text?: string | null;
};

export enum PriceInterval {
  MONTH = 'month',
  YEAR = 'year',
  ONE_TIME = 'one_time',
  DONATION = 'donation',
}

export interface Price {
  id: string;
  amount_cents: number;
  original_amount_cents: number;
  currency: string;
  interval: PriceInterval;
  denominator: string;
  cta: string;
  features: string[] | null;
  premium_offer?: PremiumOffer;
}

export interface Tier {
  id: string;
  name: string;
  description: string;
  prices: Price[];
  redirect_url: string;
  gifting_enabled: boolean;
}

export interface PricingDetails {
  tiers: Tier[];
}

export interface StripePremiumSession {
  session: string;
}

export interface PaidTrialInfo {
  ends_at: string;
  trial_price_cents: number;
  trial_billing_cadence: string;
  regular_price_cents?: number;
  regular_billing_cadence?: string;
  currency?: string;
}

export interface SubscriptionPremiumTier {
  id: string;
  name: string;
  permanent: string;
  gift_details: null | string;
  paid_trial_info?: PaidTrialInfo | null;
}

export interface SubscriptionBillingSummary {
  pending_downgrade: boolean;
  prorated_downgrade_available: boolean;
  last_invoice: {
    amount_cents: number | null;
    cadence: string | null;
    interval_count: number | null;
    timestamp: string | null;
    currency: string | null;
    discount?: number;
  } | null;
  next_invoice: {
    amount_cents: number;
    cadence: string;
    interval_count: number | null;
    timestamp: string;
    currency: string;
    discount?: number;
  } | null;
  price_id: string | null;
}

export interface SubscriptionBillingDetails {
  brand?: string;
  last4?: string;
  exp_month?: number;
  exp_year?: number;
  name?: string;
  email?: string;
  phone?: string;
  address?: {
    line1: string;
    line2: string;
    state: string;
    city: string;
    country: string;
    postal_code: string;
  };
  tax_ids?: [
    {
      type: string;
      value: string;
    },
  ];
}

export interface Subscription {
  id: string;
  status: string;
  tier: string;
  tier_names: string[];
  email: string;
  first_name: string;
  last_name: string;
  one_click_unsubscribe_status: null | boolean;
  stripe_customer_id: null | string;
  subscriber_id: string | undefined;
  avatar_url: string;
  comment_details_set: boolean;
  comment_publication_ban: boolean;
  comment_post_bans: string[];
  premium_tiers: SubscriptionPremiumTier[];
  password_exists: boolean;
}
